<template>
  <transition name="fade">
    <div v-if="show" class="popup_box" style="display: block">
      <div class="popup delete_category">
        <span class="page_title">Удалить [{{edit_content.id}}] {{edit_content.title}}  ?</span>
        <span class="close_popup" @click="close()"></span>
        <button class="btn" @click="close()">Отмена</button>
        <button class="btn empty" @click="confirm()">Удалить</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'DeleteContentModal',
  computed: {
    ...mapState('contents', ['edit_content', 'show_delete']),
    show: {
      get () {
        return this.show_delete
      },
      set (value) {
        this.setShowDelete(value)
      }
    }
  },
  methods: {
    ...mapActions('contents', ['deleteContent']),
    ...mapMutations('contents', ['setShowDelete', 'setEditContent']),
    close () {
      this.setEditContent(null)
      this.show = false
    },
    confirm () {
      this.deleteContent(this.edit_content.id)
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
